import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=201f04f6&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=201f04f6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f04f6",
  null
  
)

export default component.exports